import { Component, OnInit } from '@angular/core';
import { CustomerService } from 'src/app/services/customer.service';
import { Customer } from 'src/app/models/customer';
import { CustomerAddress } from 'src/app/models/customer-address';
import { ExpenseService } from 'src/app/services/expense.service';
import { Expense } from 'src/app/models/expense';
import { TravelRouteService } from 'src/app/services/travel-route.service';
import { TravelRoute } from 'src/app/models/travel-route';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { ToastrManager } from 'ng6-toastr-notifications';

export interface dir{
  lat:number,
  lng:number,
}

@Component({
  selector: 'app-route-create',
  templateUrl: './route-create.component.html',
  styleUrls: ['./route-create.component.css']
})
export class RouteCreateComponent implements OnInit {

  customers:Customer[] = [];
  targetCustomer:Customer;
  sourceCustomer:Customer;
  targetAddress:CustomerAddress;
  sourceAddress:CustomerAddress;
  loading:boolean = false;

  zoom:number = 15;
  lat: number = 19.8247011;
  lng: number = -98.9742239;

  km:string = '1 m';
  tiempo:string = '1 min';
  name:string = '';

  gas:number = 0;

  origin:dir;
  destination:dir;

  renderOptions = {
    draggable: true,
  }

  casetas:Expense[] = [];
  caseta:Expense = new Expense();
  combustibles:Expense[] = [];
  combustible:Expense = new Expense();
  expenseList:Expense[] = [];
  
  constructor(private customerServ:CustomerService, private expenseServ:ExpenseService, private routeServ:TravelRouteService, private utl:UtilitiesService, private toastr: ToastrManager) { }

  ngOnInit() {
    this.loading = true;
    this.customerServ.getCustomers().then(customers => {
      this.customers = customers.filter(x => x.type != 'Compañia');
      this.targetCustomer = this.customers[0];
      this.sourceCustomer = this.customers[0];
      this.loading = false;
    });
    this.expenseServ.getExpenses("type", "Viaje").then(expenses => {
      this.casetas = expenses.filter(exp => exp.expense_type.name == 'Casetas');
      this.caseta = this.casetas[0];
      this.combustibles = expenses.filter(exp => exp.expense_type.name == 'Combustible');
      this.combustible = this.combustibles[0];
    });
  }

  createRoute() {
    if(!this.sourceAddress || !this.targetAddress) {
      this.toastr.infoToastr("¡Las direcciones no deben ser vacias!");
      return;
    }

    if (this.expenseList.filter(x => x.expense_type.name == 'Combustible').length == 0) {
      this.toastr.infoToastr("¡Agregar por lo menos un gasto de tipo Combustible!");
      return;
    }

    let route:TravelRoute = {
      id: 0,
      expenses: this.expenseList.map(x => x.id),
      source_customer_address_id: this.sourceAddress.id,
      source_customer_address: this.sourceAddress,
      target_customer_address_id: this.targetAddress.id,
      target_customer_address: this.targetAddress,
      time: this.utl.timeStringToInt(this.tiempo),
      meters: this.utl.distanceStringToInt(this.km),
      gas: this.gas,
      name: this.name,
      source_customer: null,
      target_customer: null,
    };
    
    this.loading = true;
    this.routeServ.postTravelRoute(route).then(x => {
      this.loading = false;
      this.toastr.successToastr('Ruta creada correctamente');
    }).catch(e => {
      this.toastr.errorToastr(this.utl.formatMessages(e), 'Oops!', { enableHTML: true });
      this.loading = false;
    });
  }

  changeOriginC() {
    if (this.sourceCustomer.directions.length) {
      this.sourceAddress = this.sourceCustomer.directions[0];
      this.changeOrigin();
    }
  }
  
  changeDestinationC() {
    if (this.targetCustomer.directions.length) {
      this.targetAddress = this.targetCustomer.directions[0];
      this.changeDestination();
    }
  }

  changeOrigin() {
    this.origin = {
      lat: Number(this.sourceAddress.latitude),
      lng: Number(this.sourceAddress.longitude),
    }
  }
  
  changeDestination() {
    this.destination = {
      lat: Number(this.targetAddress.latitude),
      lng: Number(this.targetAddress.longitude),
    }
  }

  onChange(event) {
    this.km = event.routes[0].legs[0].distance.text;
    this.tiempo = event.routes[0].legs[0].duration.text;
  }

  addExpense() {
    for(let i = 0; i < this.expenseList.length; i++) {
      if(this.expenseList[i].id == this.caseta.id)
        return;
    }

    this.expenseList.push(this.caseta);
  }

  addComb() {
    for(let i = 0; i < this.expenseList.length; i++) {
      if(this.expenseList[i].id == this.combustible.id)
        return;
    }

    this.expenseList.push(this.combustible);
  }

  removeExpense(expense:Expense) {
    let tmp:Expense[] = [];
    for(let i = 0; i < this.expenseList.length; i++) {
      if(this.expenseList[i].id != expense.id)
        tmp.push(this.expenseList[i]);
    }

    this.expenseList = tmp;
  }

}
